import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectSelection } from '../../editor.reducer';
import { EditorService } from '../../editor.service';
import { HyperlinkDialogComponent } from '../../text-elements/hyperlink-dialog/hyperlink-dialog.component';
import {MatDialog } from '@angular/material/dialog';
import { removeHyperlink, updateAndFocusHyperlink } from '../commands';
import { EditorView } from 'prosemirror-view';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sfo-selection-actions',
    template: `
@if (selection$ | async; as data) {
  <div class="flex">
    @if (data?.selectedAnchors) {
      <div class="flex">
        @if (data.selectedAnchors[0]) {
          <a
            mat-icon-button
            [href]="data.selectedAnchors[0].anchor.attrs.href"
            target="_blank"
            rel="noopener"
            [matTooltip]="'Open link (or Ctrl+Click link)'"
            >
            <mat-icon>link</mat-icon>
          </a>
        }
        @if (data.selectedAnchors[0]) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          @if (data.selectedAnchors[0]) {
            <button
              mat-menu-item
              (click)="editLink(data.selectedAnchors[0])"
              [matTooltip]="'Edit Link'"
              >
              <mat-icon>link</mat-icon>
              <span>Edit link</span>
            </button>
          }
        </mat-menu>
      </div>
    }
  </div>
}
`,
    styleUrls: ['./selection-actions.component.css'],
    standalone: false
})
export class SelectionActionsComponent implements OnInit, OnDestroy {

  selection$ = this.store.select(selectSelection);
  view: EditorView | null;
  private selectionSub?: Subscription;

  constructor(private store: Store, public dialog: MatDialog, private editorservise: EditorService) {
    // FIXME #18 we should find a way to get the events directly 
    // from the component portal instead of using a global service
    this.editorservise.currentView.subscribe(view => this.view = view );
  }

  ngOnInit(): void {
    this.selectionSub = this.selection$.subscribe();
  }

  ngOnDestroy(): void {
    this.selectionSub?.unsubscribe();
  }

  editLink(anchor) {
    let dialogRef = this.dialog.open(HyperlinkDialogComponent, {
      data: {
        text: anchor.node.text,
        attrs: anchor.anchor.attrs,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.delete) {
        return removeHyperlink(result.id)(this.view?.state, this.view?.dispatch);
      } 
      if (result && !result.isNew && result.attrs && result.attrs.id) {
        return updateAndFocusHyperlink(result.attrs.id, result.attrs, result.text)(this.view?.state, this.view?.dispatch);
      }
      return;
    });
  }

}
